export default __webpack_public_path__ + "static/iphonex-immersion-e92e3d79415764de08fd8fecb40cb10e.png";